import React, { Component } from "react";
import SelectAddForm from "./SelectAddForm";
import "./AddQuoteForm.scss";
import { dbListThinh } from "../utils/fbdb";
export default class AddQuoteForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      thinh: {
        quote: '',
        type: '',
      },
    };
  }
  onChangeInput = (e) => {
    const { name, value } = e.target;
    this.setState({
      thinh: { ...this.state.thinh, [name]: value },
    });
  };
  onSubmitThinh = (e) => {
    e.preventDefault();
    dbListThinh.push(this.state.thinh);
    this.setState({
      thinh: { type: "male", quote: "" },
    });
  };
  render() {
    return (
      <div className="flex-childBox contain-margin">
        <h2 className="text-center">Add Thính</h2>
        <form onSubmit={this.onSubmitThinh}>
          <label
            htmlFor="price"
            className="block text-sm font-medium text-gray-700"
          >
            Quote
          </label>
          <div className="mt-1 relative rounded-md shadow-sm">
            <textarea
              value={this.state.thinh.quote}
              type="text"
              name="quote"
              id="quote"
              className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-7 pr-12 sm:text-sm border-gray-300 rounded-md"
              placeholder="quote"
              onChange={this.onChangeInput}
            />
          </div>
          <div className="text-center m-5">
            <button
              disabled={!this.state.thinh.quote}
              className="button_add_submit"
              type="submit"
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    );
  }
}
